import "./WaitTimesBanner.scss"
import {useWaitTimes} from "../../helpers/waitTimesHelper";
import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { baseUrl } from '../../helpers/configHelper';
import React from "react";

export const WaitTimesBanner = () => {
    const {
        waitingRange,
        waitingLabel,
        displayWaitTimes
    } = useWaitTimes();

    return <IonGrid className="waiting-banner">
        <IonRow className="waiting-container">
            <IonCol className="stopwatch-container">
                <img src={`${baseUrl()}/images/assets/stopwatch_icon.svg`} className="stopwatch" />
            </IonCol>
            <IonCol className="waiting-text">
                <IonRow className="ion-justify-content-center">
                    <h2><strong>Current order wait <span className="nowrap">time is</span></strong></h2>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <h2 className="time-indicator"><strong>{waitingLabel} <span className="big-time-indicator">{waitingRange}</span> minutes</strong></h2>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <span>This is an estimate based on recent orders. Times may vary.</span>
                </IonRow>
            </IonCol>
        </IonRow>
    </IonGrid>
}
